module.exports = __webpack_public_path__ + "static/img/uniqueBg1.8950a609.png";